import { useContext, useState } from "react";
import { UserContext } from '../../contexts/UserContext';
import { Stack,  Menu, MenuItem } from "@mui/material";
import {AccountCircle} from '@mui/icons-material';
import { useNavigate } from "react-router-dom";
import { useTranslation } from 'react-i18next';

export default function Profile() {
  const { userInfo, logout } = useContext(UserContext);
  const { t } = useTranslation();
  
    const [anchorEl, setAnchorEl] = useState(null);
    const navigate = useNavigate();

    const username  = userInfo ? userInfo.name : '';
     const handleLogout = () => {
      logout();
      navigate('/login');
    };
  
    const handleMenu = (event) => {
      setAnchorEl(event.currentTarget);
    };
  
    const handleClose = () => {
      setAnchorEl(null);
    };
    return (
      <Stack direction="row" alignItems={"center"} >
          <AccountCircle fontSize="large" onClick={handleMenu}/>
          <Menu
                id="menu-appbar"
                anchorEl={anchorEl}
                anchorOrigin={{
                  vertical: 'top',
                  horizontal: 'right',
                }}
                keepMounted
                transformOrigin={{
                  vertical: 'top',
                  horizontal: 'right',
                }}
                open={Boolean(anchorEl)}
                onClose={handleClose}
                sx={{mt:5}}
              >
                
                <MenuItem divider disabled sx={{color:"black"}}>{username}</MenuItem>
                <MenuItem onClick={handleLogout}>{t('log_out')}</MenuItem>
              </Menu>
          </Stack>

    );
  }